(()=>{
 const init=()=>{
  if(document.documentElement.dataset.ekUsedReady)return;
  document.documentElement.dataset.ekUsedReady='true';
  const config=document.querySelector('[data-ek-used-label]');
  if(!config)return;
  let bundleTypes={},typesReady=false;
  try{bundleTypes=Object.fromEntries(JSON.parse(document.querySelector('[data-ek-bundle-types-live]')?.textContent||'[]').flat());}catch{}
  const orderBundleCards=()=>{
   if(!typesReady||!/^\/pages\/buy-any-/.test(location.pathname))return;
   const group=type=>/^toys?\b/i.test(type)?0:/\b(art|craft)/i.test(type)?1:/^books?\b/i.test(type)?2:3;
   document.querySelectorAll('.bxq-grid').forEach(grid=>{
    const cards=[...grid.children].filter(card=>card.matches('.bxq-card'));
    cards.forEach((card,index)=>{if(!card.dataset.ekBundleOriginalIndex)card.dataset.ekBundleOriginalIndex=String(index+1);card.dataset.ekBundleCategory=bundleTypes[(card.dataset.productId||'').split('/').pop()]||'';});
    const sorted=[...cards].sort((a,b)=>{const first=a.dataset.ekBundleCategory,second=b.dataset.ekBundleCategory;return group(first)-group(second)||(group(first)===3?first.localeCompare(second):0)||Number(a.dataset.ekBundleOriginalIndex)-Number(b.dataset.ekBundleOriginalIndex);});
    if(sorted.some((card,index)=>card!==cards[index])){const focused=document.activeElement;const restore=grid.contains(focused);sorted.forEach(card=>grid.append(card));if(restore&&focused.isConnected)focused.focus({preventScroll:true});}
   });
  };

  const orderBooksByWeight=()=>{
   if(location.pathname.replace(/\/$/,'')!=='/pages/books')return;
   document.querySelectorAll('.bxq-grid').forEach(grid=>{
    const cards=[...grid.children].filter(card=>card.matches('.bxq-card'));
    const grams=card=>{
     const text=card.querySelector('.bxq-variant')?.textContent.trim()||'';
     const match=text.match(/^([\d,]+(?:\.\d+)?)\s*(kg|g)$/i);
     return match?Number(match[1].replace(/,/g,''))*(match[2].toLowerCase()==='kg'?1000:1):Infinity;
    };
    const ordered=[...cards].sort((a,b)=>grams(a)-grams(b));
    if(ordered.some((card,index)=>card!==cards[index])){
     const focused=document.activeElement;const restore=grid.contains(focused);
     ordered.forEach(card=>grid.append(card));
     if(restore&&focused.isConnected)focused.focus({preventScroll:true});
    }
   });
  };
  const categories=['','Toys','Books','Art & Craft Essentials','Gadgets','Kids Accessories','School Supplies'];
  const selections=new Map();
  document.addEventListener('click',event=>{const button=event.target.closest('[data-combo-action]');if(!button)return;const root=button.closest('[data-brix-combo-root]');if(!root)return;if(button.dataset.comboAction==='qs-pick'&&button.dataset.menu==='type')selections.set(root,button.dataset.value||'');if(button.dataset.comboAction==='qs-clear')selections.set(root,'');},true);
  const used=/\bBKLT\s*[-_]?\d+/i;
  const badge=(media)=>{
   if(!media||media.matches('html,body')||media.querySelector('.ek-book-condition--used,.ek-used-image-label'))return;
   media.classList.add('ek-used-image-host');
   const label=document.createElement('span');label.className='ek-used-image-label';label.textContent=config.dataset.ekUsedLabel;media.append(label);
  };
  const scan=()=>{
   orderBundleCards();
   orderBooksByWeight();
   if(location.pathname.replace(/\/$/,'')==='/pages/books')document.querySelectorAll('.bxq-layout').forEach(layout=>{
    layout.classList.add('ek-book-icon-filters');
    layout.querySelectorAll('.bxq-side-sec').forEach(group=>{
     if(group.querySelector('.ek-book-filter-options'))return;
     const buttons=[...group.children].filter(element=>element.matches('button[data-combo-action="qs-pick"]'));
     if(!buttons.length)return;
     const row=document.createElement('div');row.className='ek-book-filter-options';
     buttons.forEach(button=>row.append(button));group.append(row);
    });
   });
   document.querySelectorAll('[data-ek-category-empty-note]').forEach(note=>{if(note.closest('.bxq')?.querySelector('.bxq-card'))note.remove();});
   document.querySelectorAll('.bxq-pop-main img').forEach(img=>{if(used.test(img.alt))badge(img.parentElement);});
   document.querySelectorAll('.bxq-card,.ekh-product,.ek-related-card,.product-item,.ekl-result').forEach(card=>{
    const title=card.querySelector('.bxq-name,.card-title,.ekh-product-title,h2,h3')?.textContent||'';
    const img=card.querySelector('.bxq-media img,.card-media img,.ekh-product-media img,img');
    if(used.test(title+' '+(img?.alt||'')))badge(card.querySelector('.bxq-media,.card-media,.ekh-product-media,.ek-related-image')||img?.parentElement);
   });
   document.querySelectorAll('a[href*="/products/"]>img').forEach(img=>{
    if(used.test(img.alt))badge(img.parentElement);
   });
   if(config.dataset.ekProductUsed==='used'){
    const gallery=document.querySelector('[data-image-gallery-main]');
    if(gallery)gallery.querySelectorAll('.productView-image').forEach(badge);
    const family=document.querySelector('.ekx-gallery');
    if(family)badge(family);
   }
   if(/^\/pages\/buy-any-/.test(location.pathname))document.querySelectorAll('.bxq-filters').forEach(filters=>{
    if(filters.querySelector('[data-combo-action="qs-menu"][data-menu="type"]'))return;
    if(filters.querySelector('[data-ek-category-fallback]'))return;
    const wrap=document.createElement('div');wrap.className='bxq-dd ek-category-icons';wrap.dataset.ekCategoryFallback='true';
    const menu=document.createElement('div');menu.className='bxq-menu';menu.setAttribute('role','listbox');
    const root=filters.closest('[data-brix-combo-root]');
    categories.forEach(value=>{const button=document.createElement('button');button.type='button';button.className='bxq-opt';button.dataset.comboAction='qs-pick';button.dataset.menu='type';button.dataset.value=value;button.setAttribute('role','option');button.setAttribute('aria-selected',String(value===(selections.get(root)||'')));button.textContent=value||config.dataset.ekCategoryAll||'All';menu.append(button);});
    wrap.append(menu);filters.append(wrap);filters.classList.add('ek-category-filter-row');
    const builder=filters.closest('.bxq');
    if(builder&&!builder.querySelector('.bxq-card')&&!builder.querySelector('[data-ek-category-empty-note]')){const note=document.createElement('p');note.dataset.ekCategoryEmptyNote='true';note.textContent=config.dataset.ekCategoryEmpty;filters.after(note);}
   });
   if(/^\/pages\/buy-any-/.test(location.pathname))document.querySelectorAll('[data-combo-action="qs-menu"][data-menu="type"]').forEach(trigger=>{
    const wrap=trigger.closest('.bxq-dd');
    if(!wrap)return;
    const menu=wrap.querySelector('.bxq-menu');
    if(menu){
     wrap.classList.add('ek-category-icons');
     const filter=wrap.closest('.bxq-filters');filter?.classList.add('ek-category-filter-row');
    }else{
     wrap.classList.remove('ek-category-icons');
     if(trigger.getAttribute('aria-expanded')==='false')trigger.click();
    }
   });
   document.querySelectorAll('.ek-category-icons>.bxq-menu').forEach(menu=>{
    const buttons=[...menu.children].filter(button=>button.matches('[data-combo-action="qs-pick"][data-menu="type"]'));
    const rank=button=>{const value=button.dataset.value||'';return !value?0:/^toys?\b/i.test(value)?1:/^books?\b/i.test(value)?2:/\b(art|craft)/i.test(value)?3:4;};
    const ordered=[...buttons].sort((a,b)=>rank(a)-rank(b)||(rank(a)===4?(a.dataset.value||'').localeCompare(b.dataset.value||''):0));
    if(ordered.some((button,index)=>button!==buttons[index])){const focused=document.activeElement;const restore=menu.contains(focused);ordered.forEach(button=>menu.append(button));if(restore&&focused.isConnected)focused.focus({preventScroll:true});}
   });
  };
  let pending=false;
  const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;scan();});};
  new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes,...record.removedNodes].some(node=>node.nodeType===1&&!node.classList?.contains('ek-used-image-label'))))schedule();}).observe(document.body,{childList:true,subtree:true});
  scan();
  if(config.dataset.ekBundleTypesUrl)fetch(config.dataset.ekBundleTypesUrl).then(response=>{if(!response.ok)throw new Error('Product types unavailable');return response.json();}).then(types=>{bundleTypes={...types,...bundleTypes};}).catch(()=>{}).finally(()=>{typesReady=true;schedule();});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
